module.exports = __webpack_public_path__ + "@/assets/img/logo-onmex.43fade55.png";